import styled from "styled-components";
import { device } from "../utlis/device";

const InputContainer = styled.div `
  padding: 10px;
  cursor: pointer;
  z-index: 999999999;
  width: 60%;
  margin: auto;
`
const InputStyle = styled.input `
   white-space: normal;
   /* word-break:break-all; */
   font-size: 20px;
   font-family: inherit;
   font-weight: bold;
   padding: 5px 20px;
   border-radius: 15px;
   border: none;
   cursor: pointer;
   background-color: ${props => props.backgroundColor};
   color: #f5f0e5;
   z-index: 999999999;
   @media ${device.mobileL} {
  }
  @media ${device.mobileM} {

  }
  @media (max-width: 320px) {
  }
`

function Input(props) {
    return (
      <InputContainer>
          <InputStyle 
            name={props.name} 
            type={props.type} 
            value={props.value} 
            placeholder={props.placeholder} 
            onClick={props.onClick} 
            backgroundColor={props.backgroundColor}>{props.text}
          </InputStyle>
      </InputContainer>
    );
  }
  
  export default Input;